import LinkButton, { LinkButtonProps } from '@carvana/ds-link-button';
import { AnalyticsAttributes } from '@carvana/merch-components/contracts';
import cx from 'classnames';
import React from 'react';
import useTextButtonHandler from '~/hooks/vdp/cta/useTextButtonHandler';
import useTextCtaButtonCopy from '~/hooks/vdp/selectors/useTextCtaButtonCopy';
import useTextCtaButtonState from '~/hooks/vdp/selectors/useTextCtaButtonState';

const dummyFunction = () => {};

type OwnProps<T> = {
  ButtonComponent?: React.ComponentType<any>;
  className?: string;
  'data-analytics-id': string | null;
  'data-analytics-attributes'?: AnalyticsAttributes;
  'data-testid'?: string;
  onClick?: () => void;
} & T;

export default function TextCtaButton<T = LinkButtonProps>({
  ButtonComponent = LinkButton,
  className = '',
  'data-analytics-id': analyticsId,
  'data-analytics-attributes': analyticsAttributes,
  'data-testid': testId,
  onClick = dummyFunction,
  ...rest
}: OwnProps<T>) {
  const handleOnClick = useTextButtonHandler(onClick) ?? dummyFunction;
  const { isDisabled, textAlignClass } = useTextCtaButtonState();
  const textCtaText = useTextCtaButtonCopy();

  return textCtaText ? (
    <ButtonComponent
      className={cx('!no-underline', textAlignClass, className)}
      disabled={isDisabled}
      onClick={handleOnClick}
      data-adobe-id={null}
      data-analytics-id={analyticsId}
      data-analytics-attributes={JSON.stringify({
        ...analyticsAttributes,
        description: 'text cta',
        text: textCtaText
      })}
      data-testid={testId}
      variant="default"
      {...rest}
    >
      {textCtaText}
    </ButtonComponent>
  ) : null;
}
